import { render, staticRenderFns } from "./SpecialtyInfo.vue?vue&type=template&id=32e66052&scoped=true"
import script from "./SpecialtyInfo.vue?vue&type=script&lang=js"
export * from "./SpecialtyInfo.vue?vue&type=script&lang=js"
import style0 from "./SpecialtyInfo.vue?vue&type=style&index=0&id=32e66052&prod&scoped=true&lang=css"
import style1 from "./SpecialtyInfo.vue?vue&type=style&index=1&id=32e66052&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32e66052",
  null
  
)

export default component.exports